import AODLayout from "../components/AdmissionsOfficeDatabase/AODLayout";

const AdmissionsOfficeDatabasePage = () => {
  return <AODLayout />;
};

export default AdmissionsOfficeDatabasePage;
